import { Controller } from "@hotwired/stimulus"

// UI-05: one slide at a time, auto-advancing; Prev/Next, swipe, and a pause
// while the screen is pressed.
export default class extends Controller {
  static targets = ["slide"]
  static values = { interval: { type: Number, default: 5000 } }

  connect() {
    this.index = Math.max(0, this.slideTargets.findIndex((slide) => !slide.hidden))
    this.show()
    this.start()
  }

  disconnect() {
    this.stop()
  }

  next() {
    this.index = (this.index + 1) % this.slideTargets.length
    this.show()
    this.restart()
  }

  previous() {
    this.index = (this.index - 1 + this.slideTargets.length) % this.slideTargets.length
    this.show()
    this.restart()
  }

  pointerDown(event) {
    this.startX = event.clientX
    this.stop()
  }

  pointerUp(event) {
    const dx = event.clientX - (this.startX ?? event.clientX)
    if (Math.abs(dx) > 50) dx < 0 ? this.next() : this.previous()
    else this.start()
  }

  // private

  show() {
    this.slideTargets.forEach((slide, i) => { slide.hidden = i !== this.index })
  }

  start() {
    this.stop()
    if (this.slideTargets.length > 1) this.timer = setInterval(() => this.next(), this.intervalValue)
  }

  restart() {
    if (this.timer) this.start()
  }

  stop() {
    clearInterval(this.timer)
    this.timer = null
  }
}
